"use client";

import createIcon from './util/createIcon';
export default createIcon('M10,5V11H21V5M16,18H21V12H16M4,18H9V5H4M10,18H15V12H10V18Z', 'ViewQuilt');